/**
 * 根据权限配置菜单
 * 每一个menu项参数：key, label, path, number 显示提示数字, query 查询对象, icon
 */
import Permit from '@/utils/permit.js';
import Bargain from '@/api/bargain.js';
import Order from '@/api/order.js';
import Purchase from '@/api/purchase.js';
import Reminder from '@/api/reminder.js';
import Delivery from '@/api/delivery.js';
import PickShelf from '@/api/pickShelf.js';
import PushShelf from '@/api/pushShelf.js';
import Allocate from '@/api/allocate.js';
import Damage from '@/api/damage.js';
import Receive from '@/api/receive.js';
import Quality from '@/api/quality.js';
// import Rework from "@/api/rework.js";
import ReturnBack from '@/api/returnBack.js';
import OrderMes from '@/api/orderMes.js';
import WorkOrder from '@/api/workOrder.js';
import ReceiveMms from '@/api/receiveMms.js';
import DeliveryRequisition from '@/api/deliveryRequisition.js';
import InventoryForceOut from '@/api/inventoryForceOut.js';
import Rework from '@/api/rework.js';
import Material from '@/api/material.js';

// console.log(Permit.currentUser().name, "====normalMenu:", Permit.extendModels())
let menus = [];
menus.push({
  key: 'Dashboard',
  label: '主工作台',
  path: '/normal/dashboard',
  icon: 'dashboard',
});
if (
  ['charge', 'af'].includes(Permit.edition()) &&
  Permit.extendModels().includes('oms')
) {
  let omsMenu = { key: 'oms', label: '订单管理', icon: 'oms', children: [] };
  if (Permit.canActions('orderView')) {
    if (Permit.currentTenant().config.bulkOrder) {
      omsMenu.children.push({
        key: 'omsBargainsBulk',
        label: '销售单',
        path: '/normal/oms/bargainsBulk',
      });
    } else {
      omsMenu.children.push({
        key: 'omsBargains',
        label: '销售单',
        path: '/normal/oms/bargains',
      });
    }
    omsMenu.children.push({
      key: 'omsOrders',
      label: '销售单项',
      path: '/normal/oms/orders',
    });
  }

  if (
    ['charge'].includes(Permit.edition()) &&
    Permit.canActions('replenishOrderView')
  ) {
    omsMenu.children.push({
      key: 'omsReplenishs',
      label: '备货订单',
      path: '/normal/oms/replenishs',
    });
  }
  if (
    ['charge'].includes(Permit.edition()) &&
    Permit.canActions('orderConfirm')
  ) {
    omsMenu.children.push({
      key: 'omsUnconfirms',
      label: '未确认',
      path: '/normal/oms/unconfirms',
      numberFun: Bargain.pendingConfrimCount,
      emitNames: [
        'orderNew',
        'orderCopy',
        'bargainCopy',
        'deleteOrder',
        'deleteBargain',
        'cancelConfirm',
        'orderBatchConfirm',
      ],
    });
  }

  if (
    !Permit.isFreeEdition() &&
    Permit.canActionsChargeEdition('orderManage')
  ) {
    omsMenu.children.push({
      key: 'omsBargainsSameCustomer',
      label: '可合并订单',
      path: '/normal/oms/bargains-same-customer',
      numberFun: Bargain.sameCustomerCount,
      emitNames: [
        'BargainMergeBargain',
        'BargainCreate',
        'deleteBargain',
        'bargainCopy',
        'OrderCopyToNewBargain',
      ],
    });
  }
  //===
  if (Permit.canActions('customerView')) {
    omsMenu.children.push({
      key: 'omsCustomers',
      label: '客户档案',
      path: '/normal/oms/customers',
    });
  }
  if (
    ['charge'].includes(Permit.edition()) &&
    Permit.canActions('deliveryRequisitionView')
  ) {
    omsMenu.children.push({
      key: 'omsDeliveryRequisitions',
      label: '发货申请单',
      path: '/normal/oms/delivery-requisitions',
    });
  }
  if (Permit.canActions('orderReturn')) {
    omsMenu.children.push({
      key: 'toDoListsCustomerReturns',
      label: '退货单',
      path: '/normal/to-do-lists/customer-returns',
      numberFun: ReturnBack.unFinishCount,
      emitNames: ['orderReturnBack', 'returnBackCreate', 'returnBackDelete'],
    });
  }

  if (omsMenu.children.length != 0) {
    menus.push(omsMenu);
  }
}
//================
if (
  ['charge', 'af'].includes(Permit.edition()) &&
  Permit.extendModels().includes('oms')
) {
  let omsControlMenu = {
    key: 'omsControl',
    label: '货控管理',
    icon: 'omsControl',
    children: [],
  };
  if (
    Permit.canActions('orderDeal-available') ||
    Permit.canActions('orderDeal-manufacture') ||
    Permit.canActions('orderDeal-purchase') ||
    Permit.canActions('orderDeal-remake') ||
    Permit.canActions('orderDeal-reject')
  ) {
    omsControlMenu.children.push({
      key: 'omsPendings',
      label: '待处理',
      path: '/normal/oms/pendings',
      numberFun: Order.pendingCount,
      emitNames: [
        'orderBatchConfirm',
        'orderNew',
        'orderAvailableRepending',
        'orderBatchPrepared',
        'orderBatchProcessing',
        'orderBatchPurchase',
        'orderManufactureRepending',
        'purchaseRetrieve',
        'orderReject',
        'orderRemakeManufacture',
        'orderRemakePurchase',
        'OrderKnockDeal',
      ],
    });
  }
  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    Permit.canActions('orderDeal-available') &&
    Permit.canActionsConfigDealType('available')
  ) {
    omsControlMenu.children.push({
      key: 'omsPreparings',
      label: '备货中',
      path: '/normal/oms/preparings',
      numberFun: Order.preparingCount,
      emitNames: [
        'orderAvailableRepending',
        'orderBatchPrepareing',
        'orderAvailablePartDeal',
        'orderBatchPrepared',
      ],
    });
  }
  if (
    ['charge', 'bf'].includes(Permit.edition()) &&
    Permit.canActions('orderDeal-purchase') &&
    Permit.canActionsConfigDealType('purchase')
  ) {
    omsControlMenu.children.push({
      key: 'omsPurchasings',
      label: '外采中',
      path: '/normal/oms/purchasings',
      numberFun: Order.purchasingCount,
      emitNames: [
        'orderBatchPurchase',
        'orderRemakePurchase',
        'receiveBatchReceive',
        'receiveBatchReceiveAndQuality',
        'receiveBatchReceiveAndQualityAndPush',
        'receiveBatchReceiveAndQualityAndDelivery',
        'purchaseBatchForceReceive',
        'purchaseChangeSpecsForeceReceive',
      ],
    });
  }
  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    Permit.canActions('orderDeal-manufacture') &&
    Permit.canActionsConfigDealType('manufacture')
  ) {
    omsControlMenu.children.push({
      key: 'omsProcessings',
      label: '生产中',
      path: '/normal/oms/processings',
      numberFun: Order.processingCount,
      emitNames: [
        'orderBatchProcessing',
        'orderRemakeManufacture',
        'orderManufacturePartDeal',
        'orderBatchProcessed',
        'orderBatchScanProcessed',
        'receiveBatchReceive',
        'receiveBatchReceiveAndQuality',
        'receiveBatchReceiveAndQualityAndPush',
        'receiveBatchReceiveAndQualityAndDelivery',
        'WorkOrderChangeSpecsForeceReceive',
        'WorkOrderBatchForeceReceive',
      ],
    });
  }
  if (omsControlMenu.children.length != 0) {
    menus.push(omsControlMenu);
  }
}
//==================
if (
  ['charge', 'bf'].includes(Permit.edition()) &&
  Permit.extendModels().includes('pms') &&
  Permit.canActionsConfigDealType('purchase')
) {
  let pmsMenu = { key: 'pms', label: '外采管理', icon: 'pms', children: [] };
  if (Permit.canActions('purchaseView')) {
    pmsMenu.children.push({
      key: 'pmsPurchases',
      label: '外采单',
      path: '/normal/pms/purchases',
    });
  }
  if (Permit.canActions('purchaseRetrivePlace')) {
    pmsMenu.children.push({
      key: 'pmsNewlys',
      label: '未下单',
      path: '/normal/pms/newlys',
      numberFun: Purchase.newlyCount,
      emitNames: [
        'purchaseCreate',
        'purchaseInsertBatch',
        'purchaseCopy',
        'purchaseDelete',
        'purchasePlace',
      ],
    });
  }
  if (Permit.canActions('supplierView')) {
    pmsMenu.children.push({
      key: 'pmsSuppliers',
      label: '供应商',
      path: '/normal/pms/suppliers',
    });
  }
  if (
    ['charge'].includes(Permit.edition()) &&
    Permit.canActions('purchaseReminder')
  ) {
    pmsMenu.children.push({
      key: 'pmsReminders',
      label: '我的催单',
      path: '/normal/pms/reminders',
      numberFun: Reminder.reminderCount,
      emitNames: ['reminderInsertBatch'],
    });
  }
  if (pmsMenu.children.length != 0) {
    menus.push(pmsMenu);
  }
}
//==============
if (
  ['charge'].includes(Permit.edition()) &&
  Permit.extendModels().includes('mms')
) {
  let mmsMenu = { key: 'mms', label: '物料管理', icon: 'mms', children: [] };
  if (Permit.canActions('mmsPendingRequisitionsView')) {
    mmsMenu.children.push({
      key: 'mmsPendingsOrders',
      label: '待发料',
      path: '/normal/mms/pendings/orders',
      numberFun: Purchase.pendingRequisitionsTotalCount,
      emitNames: [
        'orderBatchPurchase',
        'orderBatchProcessing',
        'purchaseCreate',
        'purchaseInsertBatch',
        'purchasePlace',
        'RequisitionDirectFeedOrderMatierials',
      ],
    }); //进页面区分订单外采单
  }
  if (Permit.canActions('mmsRequisitionView')) {
    mmsMenu.children.push({
      key: 'mmsRequisitions',
      label: '发料单',
      path: '/normal/mms/requisitions',
    }); //数字是未发料
  }
  if (Permit.canActions('mmsPendingRequisitionsView')) {
    mmsMenu.children.push({
      key: 'mmsLackStatisticsCount',
      label: '缺料统计',
      path: '/normal/mms/lack-statistics/count',
      // numberFun: Material.lackStatisticsCount,
    })
    // mmsMenu.children.push({
    //   key: 'mmsLackStatistics',
    //   label: '缺料统计',
    //   path: '/normal/mms/lack-statistics',
    //   numberFun: Material.lackStatisticsCount,
    // });
  }
  if (Permit.canActions('mmsProcureView')) {
    mmsMenu.children.push({
      key: 'mmsProcures',
      label: '采购单',
      path: '/normal/mms/procures',
    }); //数字是未下单采购单
  }
  if (Permit.canActions('mmsProcureQuality')) {
    mmsMenu.children.push({
      key: 'mmsQAs',
      label: '采购待质检',
      path: '/normal/mms/qas',
      numberFun: ReceiveMms.unQualityCount,
      emitNames: [
        'receiveMmsInsertBatch',
        'receiveMmsQualityBatch',
        'receiveMmsReturn',
      ],
    });
  }
  if (Permit.canActions('mmsInventoryInOutManage')) {
    mmsMenu.children.push({
      key: 'mmsPutins',
      label: '采购待入库',
      path: '/normal/mms/putins',
      numberFun: ReceiveMms.unStorageCount,
      emitNames: ['receiveMmsQualityBatch', 'receiveMmsConfirmStorage'],
    });
  }
  // 物料库存
  let merialWM = { key: 'mmsWM', label: '物料库存', children: [] };
  if (Permit.canActions('mmsInventoryView')) {
    merialWM.children.push({
      key: 'mmsInventories',
      label: '库存',
      path: '/normal/mms/inventories',
    });
  }
  if (Permit.canActions('mmsInventoryInOutManage')) {
    merialWM.children.push({
      key: 'mmsStockIns',
      label: '入库单',
      path: '/normal/mms/stock-ins',
    });
    merialWM.children.push({
      key: 'mmsStockOuts',
      label: '出库单',
      path: '/normal/mms/stock-outs',
    });
  }
  if (Permit.canActions('mmsInventoryAllocate')) {
    merialWM.children.push({
      key: 'mmsAllocates',
      label: '调拨单',
      path: '/normal/mms/allocates',
    });
  }
  if (Permit.canActions('mmsInventorySnapshoot')) {
    merialWM.children.push({
      key: 'mmsSnapshoots',
      label: '库存结存',
      path: '/normal/mms/snapshoots',
    });
  }
  if (merialWM.children.length != 0) {
    mmsMenu.children.push(merialWM);
  }
  if (
    Permit.canActions('mmsInventoryCashs') &&
    Permit.currentTenant().config.mmsInvUseCash == true
  ) {
    mmsMenu.children.push({
      key: 'mmsCashs',
      label: '超发余料',
      path: '/normal/mms/cashs',
    });
  }
  //---
  if (Permit.canActions('mmsReturnedMaterialView')) {
    mmsMenu.children.push({
      key: 'mmsReturns',
      label: '退料单',
      path: '/normal/mms/returns',
    });
  }
  if (Permit.canActions('mmsMaterialView')) {
    mmsMenu.children.push({
      key: 'mmsMaterials',
      label: '物料',
      path: '/normal/mms/materials',
    });
  }
  if (Permit.canActions('mmsSupplierView')) {
    mmsMenu.children.push({
      key: 'mmsSuppliers',
      label: '供应商',
      path: '/normal/mms/suppliers',
    });
  }
  if (mmsMenu.children.length != 0) {
    menus.push(mmsMenu);
  }
}
if (
  ['charge'].includes(Permit.edition()) &&
  Permit.extendModels().includes('mes') &&
  Permit.canActionsConfigDealType('manufacture')
) {
  let mesMenu = { key: 'mes', label: '生产管理', icon: 'mes', children: [] };
  if (Permit.canActions('mesOrderView')) {
    mesMenu.children.push({
      key: 'mesOrders',
      label: '生产订单',
      path: '/normal/mes/orders',
    });
  }
  if (Permit.canActions('mesOrderDispatch')) {
    mesMenu.children.push({
      key: 'mesPendingDispatchs',
      label: '待派单',
      path: '/normal/mes/pending-dispatchs',
      numberFun: OrderMes.pendingDispatchCount,
      emitNames: [
        'orderBatchProcessing',
        'orderRemakeManufacture',
        'orderMesAutoDispatch',
        'orderMesManualDispatch',
        'orderMesChangeFactory',
      ],
    });
  }
  if (Permit.canActions('mesWorkOrderView')) {
    mesMenu.children.push({
      key: 'mesWorkOrders',
      label: '生产工单',
      path: '/normal/mes/work-orders',
      numberFun: WorkOrder.inProductionCount,
      emitNames: [
        'orderMesAutoDispatch',
        'orderMesManualDispatch',
        'workOrderBatchFinish',
        'manufactureBatchFinish',
        'WorkOrderBatchForeceReceive',
        'WorkOrderChangeSpecsForeceReceive',
        'qualityBatchQuality',
        'qualityQuality',
        'qualityRework',
      ],
    });
  }
  if (Permit.canActions('mesWorkOrderCheck')) {
    mesMenu.children.push({
      key: 'mesQAs',
      label: '待尾查',
      path: '/normal/mes/qas',
      numberFun: WorkOrder.pendingQaCount,
      emitNames: [
        'qaInsertBatch',
        'orderMesAutoDispatch',
        'orderMesManualDispatch',
        'qualityBatchQuality',
        'qualityQuality',
        'WorkOrderBatchForeceReceive',
        'WorkOrderChangeSpecsForeceReceive',
        'receiveBatchReceive',
        'receiveBatchReceiveAndQuality',
        'receiveBatchReceiveAndQualityAndPush',
        'receiveBatchReceiveAndQualityAndDelivery',
      ],
    });
  }
  if (Permit.canActions('mesTrackingView')) {
    let mesTrackings = { key: 'mesTrackings', label: '跟单', children: [] };
    mesMenu.children.push(mesTrackings);
    mesTrackings.children.push({
      key: 'mesTracksWorkOrder',
      label: '按工单',
      path: '/normal/mes/tracks/work-order',
      numberFun: WorkOrder.inProductionCount,
      emitNames: [
        'orderMesAutoDispatch',
        'orderMesManualDispatch',
        'workOrderBatchFinish',
        'manufactureBatchFinish',
        'WorkOrderBatchForeceReceive',
        'WorkOrderChangeSpecsForeceReceive',
      ],
    });
    mesTrackings.children.push({
      key: 'mesTracksOrder',
      label: '按订单',
      path: '/normal/mes/tracks/order',
    });
    mesTrackings.children.push({
      key: 'mesTracksWorker',
      label: '按工人',
      path: '/normal/mes/tracks/worker',
    });
  }
  if (Permit.canActions('mesRecordView')) {
    mesMenu.children.push({
      key: 'mesManufactures',
      label: '生产记录',
      path: '/normal/mes/manufactures',
    });
  }
  if (Permit.canActions('mesWorkerView')) {
    mesMenu.children.push({
      key: 'mesWorkers',
      label: '工人',
      path: '/normal/mes/workers',
    });
  }
  if (mesMenu.children.lebgth != 0) {
    menus.push(mesMenu);
  }
}
if (
  ['charge'].includes(Permit.edition()) &&
  Permit.extendModels().includes('wms')
) {
  let wmsMenu = { key: 'wms', label: '库存管理', icon: 'wms', children: [] };
  if (Permit.canActions('wmsInventoryView')) {
    wmsMenu.children.push({
      key: 'wmsInventories',
      label: '库存',
      path: '/normal/wms/inventories',
    });
  }
  if (Permit.canActions('wmsInventoryPushShelf')) {
    wmsMenu.children.push({
      key: 'wmsPushShelfs',
      label: '上架/待入库',
      path: '/normal/wms/push-shelfs',
      numberFun: PushShelf.pendingPushCount,
      emitNames: [
        'qualityBatchQuality',
        'qualityQuality',
        'receiveBatchReceiveAndQuality',
        'pickShelfBatchPick',
        'pickShelfPick',
        'pushShelfBatchPush',
        'pushShelfPush',
      ],
    });
  }
  // ==出库
  if (Permit.canActions('wmsInventoryPickShelf')) {
    let wmsMenuChildrenPickShelf = {
      key: 'wmsPickShelfs',
      label: '拣货/待出库',
      path: '/normal/wms/pick-shelfs',
      children: [],
    };
    if (Permit.currentTenant().config.invNeedPickPush) {
      wmsMenuChildrenPickShelf.children.push({
        key: 'wmsPickShelfsDelivery',
        label: '发货出库',
        path: '/normal/wms/pick-shelfs/delivery',
        numberFun: Delivery.pendingPickCount,
        emitNames: [
          'orderExpressDeliver',
          'orderCourierDeliver',
          'orderNormalDeliver',
          'deliveryRequisitionDeliver',
          'pickShelfPick',
          'pickShelfBatchPick',
        ],
      });
    }
    wmsMenuChildrenPickShelf.children.push(
      {
        key: 'wmsPickShelfsAllocate',
        label: '调拨出库',
        path: '/normal/wms/pick-shelfs/allocate',
        numberFun: PickShelf.pendingPickAllocateCount,
        emitNames: [
          'allocateApplyOut',
          'allocateAgree',
          'pickShelfBatchPick',
          'pickShelfPick',
          'allocateCancel',
        ],
      },
      {
        key: 'wmsPickShelfsRemake',
        label: '改制出库',
        path: '/normal/wms/pick-shelfs/remake',
        numberFun: PickShelf.pendingPickRemakeCount,
        emitNames: [
          'orderRemakeManufacture',
          'orderRemakePurchase',
          'pickShelfBatchPick',
          'pickShelfPick',
        ],
      },
      {
        key: 'wmsPickShelfsOther',
        label: '其他',
        path: '/normal/wms/pick-shelfs/other',
        numberFun: InventoryForceOut.unDealCount,
        emitNames: [
          'purchaseReturnBack',
          'inventoryForceOutIgnore',
          'inventoryForceOutAgree',
        ],
      }
    );
    wmsMenu.children.push(wmsMenuChildrenPickShelf);
    //===
    wmsMenu.children.push({
      key: 'wmsPickLists',
      label: '拣货清单',
      path: '/normal/wms/pick-lists',
    });
  }
  //==
  if (Permit.canActions('wmsAllocateView')) {
    wmsMenu.children.push({
      key: 'wmsAllocates',
      label: '调拨单',
      path: '/normal/wms/allocates',
      numberFun: Allocate.pendingAgreeCount,
      emitNames: [
        'allocateApplyIn',
        'allocateAgree',
        'allocateAgreeAndPick',
        'allocateReject',
        'allocateDelete',
      ],
    });
  }
  if (Permit.canActions('wmsDamageView')) {
    wmsMenu.children.push({
      key: 'wmsDamages',
      label: '报损单',
      path: '/normal/wms/damages',
      numberFun: Damage.pendingAgreeCount,
      emitNames: [
        'damageInventoryDamage',
        'damageAgree',
        'damageReject',
        'damageDelete',
      ],
    });
  }
  if (Permit.canActions('wmsInventoryStockInOut')) {
    wmsMenu.children.push({
      key: 'wmsStockInsCount',
      label: '入库单',
      path: '/normal/wms/stock-ins/count',
    });
    wmsMenu.children.push({
      key: 'wmsStockOutsCount',
      label: '出库单',
      path: '/normal/wms/stock-outs/count',
    });
  }
  if (Permit.canActions('wmsInventorySnapshoots')) {
    wmsMenu.children.push({
      key: 'wmsSnapshoots',
      label: '库存结存',
      path: '/normal/wms/snapshoots',
    });
  }
  if (wmsMenu.children.length != 0) {
    menus.push(wmsMenu);
  }
}
if (
  Permit.extendModels().includes('lmsC') ||
  Permit.extendModels().includes('lmsE') ||
  Permit.extendModels().includes('lmsO')
) {
  let lmsMenu = { key: 'lms', label: '收发货管理', icon: 'lms', children: [] };

  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    Permit.extendModels().includes('lmsC') &&
    Permit.canActions('deliverApplyTracking')
  ) {
    lmsMenu.children.push({
      key: 'lmsApplyTrackings',
      label: '申请运单号',
      path: '/normal/lms/apply-trackings',
    });
  }
  if (
    ['charge', 'bf'].includes(Permit.edition()) &&
    (Permit.canActions('receiveView') ||
      Permit.canActions('receiveReceiveQuality') ||
      (Permit.extendModels().includes('wms') &&
        Permit.canActions('receiveReceiveQualityPush') &&
        Permit.currentTenant().config.invNeedPickPush) ||
      (!Permit.isFreeEdition() &&
        Permit.canActions('receiveReceiveQualityDelivery')))
  ) {
    lmsMenu.children.push({
      key: 'lmsPendingReceives',
      label: '待收货',
      path: '/normal/lms/pending-receives',
      numberFun: Receive.pendingReceiveCount,
      emitNames: [
        'qaInsertBatch',
        'orderManufacturePartDeal',
        'orderBatchProcessed',
        'orderBatchScanProcessed',
        'purchaseCreate',
        'purchaseInsertBatch',
        'purchasePlace',
        'receiveBatchReceive',
        'receiveBatchReceiveAndQuality',
        'receiveBatchReceiveAndQualityAndPush',
        'receiveBatchReceiveAndQualityAndDelivery',
        'returnBackCreate',
        'returnBackDelete',
      ],
    });
  }
  if (
    ['charge', 'bf'].includes(Permit.edition()) &&
    Permit.canActions('receiveQuality')
  ) {
    lmsMenu.children.push({
      key: 'lmsPendingQAs',
      label: '待质检',
      path: '/normal/lms/pending-qas',
      numberFun: Quality.unQualityCount,
      emitNames: [
        'receiveBatchReceive',
        'qualityBatchQuality',
        'ReceiveBatchQualityAndDelivery',
        'qualityBatchQualityAndPush',
        'qualityQuality',
        'qualityRework',
        'purchaseBatchForceReceive',
        'WorkOrderBatchForeceReceive',
      ],
    });
  }
  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    Permit.canActions('deliverAction')
  ) {
    if (Permit.currentTenant().config.bulkOrder) {
      lmsMenu.children.push({
        key: 'lmsPendingDeliversBulk',
        label: '待发货',
        path: '/normal/lms/pending-delivers-bulk',
        numberFun: Order.pendingDeliveryCount,
        emitNames: [
          'qualityBatchQuality',
          'qualityBatchQualityAndPush',
          'qualityQuality',
          'receiveBatchReceiveAndQuality',
          'receiveBatchReceiveAndQualityAndPush',
          'orderExpressDeliver',
          'orderCourierDeliver',
          'orderNormalDeliver',
          'pushShelfBatchPush',
          'pushShelfPush',
        ],
      });
    } else {
      lmsMenu.children.push({
        key: 'lmsPendingDelivers',
        label: '待发货',
        path: '/normal/lms/pending-delivers',
        numberFun: Bargain.deliveryCount,
        emitNames: [
          'qualityBatchQuality',
          'qualityBatchQualityAndPush',
          'qualityQuality',
          'receiveBatchReceiveAndQuality',
          'receiveBatchReceiveAndQualityAndPush',
          'orderExpressDeliver',
          'orderCourierDeliver',
          'orderNormalDeliver',
          'pushShelfBatchPush',
          'pushShelfPush',
        ],
      });
    }
  }
  if (
    ['charge'].includes(Permit.edition()) &&
    Permit.canActions('deliveryRequisitionDelivery')
  ) {
    lmsMenu.children.push({
      key: 'lmsRequestDelivers',
      label: '发货申请单',
      path: '/normal/lms/request-delivers',
      numberFun: DeliveryRequisition.undeliverCount,
      emitNames: [
        'deliveryRequisitionCreate',
        'deliveryRequisitionDeliver',
        'deliveryRequisitionReject',
        'deliveryRequisitionDelete',
      ],
    });
  }
  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    Permit.canActions('deliverView')
  ) {
    lmsMenu.children.push({
      key: 'lmsDeliveries',
      label: '发货单',
      path: '/normal/lms/deliveries',
    });
  }
  if (
    ['charge', 'af'].includes(Permit.edition()) &&
    ((Permit.extendModels().includes('lmsE') &&
      Permit.canActions('requestResponseExpress')) ||
      (Permit.extendModels().includes('lmsC') &&
        Permit.canActions('requestResponseAgent')))
  ) {
    let lmsRequestResponsesChildren = [];
    if (
      Permit.extendModels().includes('lmsE') &&
      Permit.canActions('requestResponseExpress')
    ) {
      lmsRequestResponsesChildren.push({
        key: 'lmsRequestResponsesExpress',
        label: '快递',
        path: '/normal/lms/request-responses-express',
      });
    }
    if (
      Permit.extendModels().includes('lmsC') &&
      Permit.canActions('requestResponseAgent')
    ) {
      lmsRequestResponsesChildren.push({
        key: 'lmsRequestResponsesAgents',
        label: '货代',
        path: '/normal/lms/request-responses-agents',
      });
    }
    if (lmsRequestResponsesChildren.length != 0) {
      lmsMenu.children.push({
        key: 'lmsRequestResponses',
        label: '发货反馈',
        children: lmsRequestResponsesChildren,
      });
    }
  }
  if (
    ['charge', 'bf'].includes(Permit.edition()) &&
    (Permit.extendModels().includes('wms') ||
      Permit.extendModels().includes('lmsO') ||
      Permit.extendModels().includes('lmsE') ||
      Permit.extendModels().includes('lmsC')) &&
    (Permit.canActions('receiveQuality') ||
      Permit.canActions('wmsInventoryRework'))
  ) {
    lmsMenu.children.push({
      key: 'myReworks',
      label: '我的返工',
      path: '/normal/to-do-lists/my-reworks',
      numberFun: Rework.unFinishCount,
    });
  }
  if (lmsMenu.children.length != 0) {
    menus.push(lmsMenu);
  }
}
let opensFree = function () {
  return this.items.map((item) => item.key);
};
let opensCharge = function () {
  if (
    this.items.length > 1 &&
    this.items[1].children &&
    this.items[1].children.length != 0
  ) {
    return [this.items[1]].map((item) => item.key);
  }
  return [];
};
export default {
  items: menus.filter(
    (menu) => !menu.children || (menu.children && menu.children.length != 0)
  ),
  // opens: function () {
  //   return this.items.map((item) => item.key)
  // }
  // opens: function () {
  //   if (this.items.length > 1 && this.items[1].children && this.items[1].children.length != 0) {
  //     return [this.items[1]].map((item) => item.key)
  //   }
  //   return []
  // }
  opens: ['af', 'bf'].includes(Permit.edition()) ? opensFree : opensCharge,
};
